import { render } from "./HintLink.vue?vue&type=template&id=1d80d177&ts=true"
import script from "./HintLink.vue?vue&type=script&lang=ts"
export * from "./HintLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__